module.exports = __webpack_public_path__ + "img/pastel-parallax.691622ac.webp";